<template>
    <div class="operate-bar-box">
        <div class="filter-wrapper">
            <span class="filter-label">{{ globalFilter }}</span>
            <LangSelect :value="filter.language" @change="langSelectChange" :requireAll="true" class="lang-select"></LangSelect>
            <Select :initValue="filter.questionType" :options="questionOptions" class="question-select" @menuClick="questionChange" />
            <ChannelSelect :value="filter.channel" @change="channelChange" />
        </div>
        <SceneList @sceneItemClick="sceneItemClick"/>
    </div>
</template>

<script>
import Select from "@/views/zhiji/bComponents/inputs/Select";
import LangSelect from "@/components/langSelect";
import ChannelSelect from "@/views/zhiji/components/channelSelect/index";
import { questionTypeOptions } from "@/views/zhiji/components/pagesPanel/pagesConfig.js";
import SceneList from "./SceneList.vue";

export default {
    name: "TopOperateBar",
    components: {
        Select,
        ChannelSelect,
        LangSelect,
        SceneList,
    },
    props: ["data"],
    data() {
        return {};
    },
    computed: {
        filter() {
            return this.getStorePorp("filter");
        },
        questionOptions() {
            return questionTypeOptions();
        },
        questionType() {
            return this.$t("zhiji.hotSpot.questionType");
        },
        channelType() {
            return this.$t("zhiji.hotSpot.channelType");
        },
        langType() {
            return this.$t("zhiji.common.language");
        },
        globalFilter() {
            return this.$t("zhiji.likedisplay.globalFilter");
        },
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.likeDisplaySatis[propName];
        },
        questionChange(data) {
            this.$store.commit("zhiji/updatelikeSatisfFilter", {
                type: "questionType",
                data: data.value,
            })
        },
        channelChange(data) {
            this.$store.commit("zhiji/updatelikeSatisfFilter", {
                type: "channel",
                data,
            })
        },
        langSelectChange(data) {
            this.$store.commit("zhiji/updatelikeSatisfFilter", {
                type: "language",
                data: data,
            })
        },
        sceneItemClick(sceneId) {
            this.$store.commit("zhiji/updatelikeSatisfFilter", {
                type: "setId",
                data: sceneId,
            })
        }
    }
};
</script>

<style lang="less" scoped>
.operate-bar-box {
    padding: 16px 24px 6px;
    border-radius: 6px;
    background: #fff;
    border: 1px solid #d8e4f0;
    .filter-wrapper {
        display: flex;
        align-items: center;
        .filter-label {
            color: #41475E;
            font-weight: bold;
            margin-right: 20px;
        }
        .lang-select,
        .question-select {
            margin-right: 8px;
            width: 172px;
        }
    }
    .date-search {
        .data-search-label {
            margin-right: 8px;
        }

        .span-fgf {
            display: inline-block;
            vertical-align: middle;
            background: #e1eaf2;
            width: 12px;
            height: 1px;
            margin: 0 5px;
            position: relative;
            top: -1px;
        }

        .time-start,
        .time-end {
            width: 171px;
            height: 32px;
            margin-bottom: 10px;
            display: inline-block;
        }
    }

    .question-search,
    .channel-search,
    .lang-search {
        display: flex;
        align-items: center;
    }

    .channel-search {
        margin-bottom: 10px;
    }

    .question-search,
    .lang-search {
        margin: 0 8px 10px 0;
    }

    .search-type-label {
        margin-right: 8px;
    }

    .channel-select {
        width: 160px !important;
    }

    &:last-child {
        .select-opt {
            margin-right: 0;
        }
    }
}
</style>